export default __webpack_public_path__ + "img/ab2c68513e810283fe037c7b91d1089b.svg";